import currency from "currency.js";

export const convertToNumberValue = (value: any = "") => {
  // Siempre procesar con currency.js para garantizar precisión y normalización
  // Esto corrige problemas de punto flotante al redondear a 2 decimales
  return currency(value, {
    decimal: ",",
    separator: ".",
    symbol: "",
    precision: 2,
  }).value;
};

export const convertToNumber = (value: any = "") => {
  return currency(value, {
    decimal: ",",
    separator: ".",
    symbol: "",
    precision: 2,
  });
};

export const converToNumberFormat = (value: any = "") => {
  return convertToNumber(value).format();
};

export const convertToInputValue = (value: any = "") => {
  const newValue = currency(value, {
    decimal: ",",
    separator: ".",
    symbol: "",
    precision: 2,
  });

  return newValue.format().replace(/\./g, "");
};
